/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitDocumentListByCompanyIdResults,
    PressKitDocumentListByCompanyIdResultsFromJSON,
    PressKitDocumentListByCompanyIdResultsFromJSONTyped,
    PressKitDocumentListByCompanyIdResultsToJSON,
} from './PressKitDocumentListByCompanyIdResults';

/**
 * 企業のプレスキットの資料一覧
 * @export
 * @interface PressKitDocumentListByCompanyId
 */
export interface PressKitDocumentListByCompanyId {
    /**
     * 企業のプレスキットのロゴの総数
     * @type {number}
     * @memberof PressKitDocumentListByCompanyId
     */
    total: number;
    /**
     * プレスキットロゴ一覧。仕様上は最大50件。
     * @type {Array<PressKitDocumentListByCompanyIdResults>}
     * @memberof PressKitDocumentListByCompanyId
     */
    results: Array<PressKitDocumentListByCompanyIdResults>;
}

export function PressKitDocumentListByCompanyIdFromJSON(json: any): PressKitDocumentListByCompanyId {
    return PressKitDocumentListByCompanyIdFromJSONTyped(json, false);
}

export function PressKitDocumentListByCompanyIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitDocumentListByCompanyId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(PressKitDocumentListByCompanyIdResultsFromJSON)),
    };
}

export function PressKitDocumentListByCompanyIdToJSON(value?: PressKitDocumentListByCompanyId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(PressKitDocumentListByCompanyIdResultsToJSON)),
    };
}

